<div class="ui selection dropdown" uiDropdown="click">
  <i class="dropdown icon"></i>
  @if (selectedIdx < 0) {
    <div class="default text">{{hint}}</div>
  }
  @if (selectedIdx >= 0) {
    <div class="text">{{selectedValue}}</div>
  }
  <div class="menu">
    @for (item of selectList; track item; let i = $index) {
      <div class="item" (click)="onSelectValue(i)">{{item}}</div>
    }
  </div>
</div>
